import { createAsyncThunk } from '@reduxjs/toolkit';

// Simulating an API call with a delay
export const updateUserAccountAction = createAsyncThunk(
  'UPDATE_USER_ACCOUNT',
  async (payload: any, thunkApi) => {
    try {
      const simulatedApiCall = new Promise<any>((resolve, reject) => {
        setTimeout(() => {
          // Simulate a success scenario
          if (payload.username === 'validUser') {
            resolve({
              status: 200,
              data: { ...payload, updatedAt: new Date() },
            });
          } else {
            // Simulate an error scenario
            reject({ status: 400, message: 'Invalid user data' });
          }
        }, 2000);
      });

      const response = await simulatedApiCall;
      if (response?.status === 200) {
        return thunkApi.fulfillWithValue(response);
      } else {
        return thunkApi.rejectWithValue(response);
      }
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
